import { F0 } from '../../helpers/types';
import { create } from 'zustand';

type UseMenuState = {
  open: boolean;
  toggle: F0;
  close: F0;
};
export const useMenu = create<UseMenuState>((set) => ({
  open: false,
  toggle: () => set((state) => ({ open: !state.open })),
  close: () => set({ open: false }),
}));
